// extracted by mini-css-extract-plugin
module.exports = {"articleList":"ArticlesList-module__articleList___1Gk1b","article":"ArticlesList-module__article___2py4a"};